import { Component, OnInit } from '@angular/core';
import { ActivatedRoute,Router  } from '@angular/router';
import { LoginService } from '../login/login.service';
import { LoaderService } from '../../shared/services/loader.service';
import { LocalStorageService } from '../../core/local-storage.service';
import { UserProfileModel } from '../../components/profile/shared/profile.model';
import { ProfileService } from '../../components/profile/shared/profile.service';
import { RoleEnum, UserStatusCD } from '../../shared/enum/base.enum';
import { ToastrManager } from "ng6-toastr-notifications";
import { PushNotificationTokenModel } from '../login/login.model';
import { UserPermissionModel } from '../../components/user/shared/user.model';
import { UserService } from '../../components/user/shared/user.service';

@Component({
  selector: 'app-sso-login',
  templateUrl: './sso-login.component.html'
})
export class SsoLoginComponent implements OnInit {
  user: UserProfileModel = new UserProfileModel();
    notifcationTokenModel: PushNotificationTokenModel =
      new PushNotificationTokenModel();
   constructor(
    private route: ActivatedRoute,
    private router: Router,
    private _loginService : LoginService,
    private loaderService: LoaderService,
    public localStorageService: LocalStorageService,
    private profileService: ProfileService,
    private userService: UserService,
    private toastr: ToastrManager,
  ) {}

  ngOnInit() {
    this.route.queryParams.subscribe(params => {
      let encryptedString = params['data'];
      if (encryptedString) {
        encryptedString = encryptedString.replace(/^['"]|['"]$/g, '')
        this.loginWithEncrypted(encryptedString);
      } else {
         this.router.navigate(['/login']);
      }
    });
  }

  async loginWithEncrypted(encrypted: string) {
    this.loaderService.showLoader();
    this._loginService.ssoLogin(encrypted).subscribe({
      next: (res) => {
         if (res) {
            this.localStorageService.setCurrentUser(res);
            this.getUserProfile(res);
            this.loaderService.hideLoader();
          }
      },
      error: (err) => {
        this.loaderService.hideLoader();
      }
    });
  }

  async getUserProfile(res) {
      this.profileService.getUserProfile().subscribe(
        (result: UserProfileModel) => {
          if (result) {
            this.user = result;
            if (result.userStatusCD !== UserStatusCD.Approved) {
              this.loaderService.hideLoader();
              this.localStorageService.removeLogin();
              const msg = this.localStorageService.getValue(
                "AccountNotApproved",
                "en-US"
              );
              this.toastr.errorToastr(msg);
            } else {
              if (result.roleId === RoleEnum.Sub_Admin) {
                this.getUserPermission();
                // this.router.navigate(["/dashboard/welcome"]);
                this.loaderService.hideLoader();
              } else {
                this.loaderService.hideLoader();
                this.router.navigate(["/"]);
              }
            }
          }
        },
        (err) => {
          this.loaderService.hideLoader();
        }
      );
    }

  getUserPermission() {
      this.userService.getUserPermission().subscribe(
        (result: UserPermissionModel[]) => {
          this.loaderService.hideLoader();
            this.localStorageService.permission.next(result);
          this.router.navigate(["/dashboard/welcome"]);
        },
        (err) => {
          this.loaderService.hideLoader();
        }
      );
    }

}
